import { makeStyles } from "@material-ui/core/styles";
import { MenuItem, Select } from "@mui/material";
import React from "react";

import useCurrency from "../../../../../hooks/useCurrency";
import { getForeignCurrency } from "../../../../../utils/currency";

export default function CurrencyPicker({
  marketplace,
  style = {},
  disabled = false,
}) {
  const { showGBP, setShowGBP } = useCurrency();
  const foreignCurrency = getForeignCurrency(marketplace)?.code ?? "GBP";
  const currencies = [
    { label: "USD", value: "usd" },
    { label: foreignCurrency, value: foreignCurrency.toLowerCase() },
  ];
  const useStyles = makeStyles({
    selectCurrencyStyle: {
      borderRadius: "10px",
      height: "40px",
      fontWeight: "bold",
      margin: "4px",
      "& fieldset": {
        borderWidth: "2px",
      },
    },
    customStyle: style,
    selectedMenuItem: {
      backgroundColor: "#ffffff !important",
    },
  });

  const classes = useStyles();
  const value = showGBP ? foreignCurrency.toLowerCase() : "usd";

  const handleCurrencyChange = (event) => {
    setShowGBP(event.target.value === foreignCurrency.toLowerCase());
  };

  return (
    <Select
      className={`${classes.selectCurrencyStyle} ${classes.customStyle}`}
      labelId="currency-to-select-label"
      id="currency-to-select"
      value={value}
      onChange={handleCurrencyChange}
      disabled={disabled}
      MenuProps={{
        PaperProps: {
          sx: {
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "rgba(55,111,208,0.08) !important",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "rgba(0,0,0,0.04) !important",
            },
          },
        },
      }}
    >
      {currencies.map((option, index) => (
        <MenuItem
          key={`${option.value} + ${index}`}
          value={option.value}
          className={classes.selectedMenuItem}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
